import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const CalendarView = ({ 
  appointments, 
  technicians,
  onAppointmentClick,
  onDateChange,
  selectedDate 
}) => {
  const [viewMode, setViewMode] = useState('day');
  const [currentDate, setCurrentDate] = useState(selectedDate || new Date());

  const hours = Array.from({ length: 12 }, (_, i) => i + 8);

  const getAppointmentsForHour = (hour, technicianId) => {
    return appointments?.filter(apt => {
      const aptHour = parseInt(apt?.scheduledTime?.split(':')?.[0]);
      return aptHour === hour && apt?.technicianId === technicianId;
    });
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('fr-FR', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })?.format(date);
  };

  const navigateDate = (direction) => {
    const newDate = new Date(currentDate);
    if (viewMode === 'day') {
      newDate?.setDate(newDate?.getDate() + direction);
    } else if (viewMode === 'week') {
      newDate?.setDate(newDate?.getDate() + (direction * 7));
    }
    setCurrentDate(newDate);
    onDateChange(newDate);
  };

  return (
    <div className="bg-card rounded-lg border border-border">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground">Planning des interventions</h2>
          <div className="flex gap-2">
            <Button
              variant={viewMode === 'day' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setViewMode('day')}
            >
              Jour
            </Button>
            <Button
              variant={viewMode === 'week' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setViewMode('week')}
            >
              Semaine
            </Button>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronLeft"
            onClick={() => navigateDate(-1)}
          />
          <span className="text-sm font-medium text-foreground capitalize">
            {formatDate(currentDate)}
          </span>
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronRight"
            onClick={() => navigateDate(1)}
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-[800px]">
          <div className="grid grid-cols-[100px_repeat(auto-fit,minmax(150px,1fr))] border-b border-border">
            <div className="p-3 bg-muted font-medium text-sm text-foreground">Heure</div>
            {technicians?.map(tech => (
              <div key={tech?.id} className="p-3 bg-muted border-l border-border">
                <div className="font-medium text-sm text-foreground truncate">{tech?.name}</div>
                <div className="text-xs text-muted-foreground">{tech?.specialty}</div>
              </div>
            ))}
          </div>

          <div className="max-h-[600px] overflow-y-auto scrollbar-thin">
            {hours?.map(hour => (
              <div key={hour} className="grid grid-cols-[100px_repeat(auto-fit,minmax(150px,1fr))] border-b border-border min-h-[80px]">
                <div className="p-3 bg-muted/50 font-medium text-sm text-foreground">
                  {hour}:00
                </div>
                {technicians?.map(tech => {
                  const hourAppointments = getAppointmentsForHour(hour, tech?.id);
                  return (
                    <div key={tech?.id} className="p-2 border-l border-border relative">
                      {hourAppointments?.map((apt, idx) => (
                        <button
                          key={apt?.id}
                          onClick={() => onAppointmentClick(apt)}
                          className={`w-full p-2 rounded text-left text-xs mb-1 transition-all hover:shadow-md ${
                            apt?.urgency === 'urgent' ? 'bg-error/20 border border-error text-error' :
                            apt?.urgency === 'today'? 'bg-warning/20 border border-warning text-warning' : 'bg-primary/20 border border-primary text-primary'
                          }`}
                        >
                          <div className="font-medium truncate">{apt?.serviceType}</div>
                          <div className="truncate opacity-80">{apt?.customerName}</div>
                        </button>
                      ))}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarView;